/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agenda_Source_MicrosoftInputs */



/**
* | output |
* | --- |
* | "Outlook calendar" |
*
* @param {Agenda_Source_MicrosoftInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const agenda_source_microsoft = /** @type {((inputs?: Agenda_Source_MicrosoftInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agenda_Source_MicrosoftInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Outlook-agenda")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Agenda Outlook")
	return /** @type {LocalizedString} */ ("Outlook calendar")
});